import styled from "styled-components";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";

export const Button = styled.button`
  position: relative;
  width: ${({ submitText }) => (submitText ? "200px" : "150px")};
  height: 48px;

  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  text-transform: uppercase;

  padding: 0;

  background: #fff;
  margin-right: 8px;
  border-radius: 4px;
  color: ${({ color }) => (color ? color : "#4D4C4D")};
  border: ${({ color }) =>
    color ? `1px solid ${color}` : "1px solid #4D4C4D"};

  border-radius: 4px;
  transition: filter 0.4s;

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    text-decoration: ${({ variant }) =>
    variant === "cancel" ? "underline" : ""};
  }

  &:hover {
    filter: brightness(90%);
    cursor: pointer;
  }

  &:disabled {
    background: ${globalColors.textColor3};
    cursor: not-allowed;
    border-color: ${({ color }) =>
    color ? globalColors.textColor3 : "#4D4C4D88"};
  }

  ${({ variant }) =>
    variant === "primary"
      ? `
    background: ${globalColors.primaryColor2};
    color: white;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
    margin-right: 0px;
    `
      : variant === "cancel" &&
      `
      background: transparent;
      color: ${globalColors.primaryColor2};
      border-color: transparent
    `};
`;
